import {
  VISUALITZACIO_INICIALITZAR,
  VISUALITZACIO_SELECCIO_TIPUS
} from "../../actions/actionTypes";
import { MAPA } from "../../constantsFormularis";

const ESTAT_INICIAL = MAPA;

const tipusActiu = (state = ESTAT_INICIAL, action) => {
  switch (action.type) {
    case VISUALITZACIO_INICIALITZAR:
      return ESTAT_INICIAL;

    case VISUALITZACIO_SELECCIO_TIPUS:
      return action.payload;

    default:
      return state;
  }
};

export default tipusActiu;

export const getTipusActiu = state => state.tipusActiu;
